import { render, staticRenderFns } from "./PassUser.vue?vue&type=template&id=028c4fc2&"
import script from "./PassUser.vue?vue&type=script&lang=js&"
export * from "./PassUser.vue?vue&type=script&lang=js&"
import style0 from "./PassUser.vue?vue&type=style&index=0&id=028c4fc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports